<template>
  <div class="login d-flex">
 <div v-if="loginMainImage==='' || loginMainImage===undefined || loginMainImage===null" class="bg"></div>
  <div v-else class="bg1"   :style="{ background: 'url(' + loginMainImage + ')no-repeat center center / cover' }"></div>
    <div class="loginBox d-flex justify-center align-center">
      <v-card class="loginForm" flat>
        <v-card-title class="login-tit justify-center">{{
          $t('ESL DASHBOARD')
        }}</v-card-title>
          <v-card-subtitle v-show="!keycloakloginform" class="login-txt mt-1">{{
          $t('Welcome back! Please login to your account.')
        }}</v-card-subtitle>
         <v-card-subtitle v-show="keycloakloginform" class="login-txt mt-1" style="text-align:center">{{
          $t('Welcome back!')
        }}</v-card-subtitle>
        <v-card-text class="mt-7" v-show="!keycloakloginform">
          <v-form>
            <v-select
              v-model="loginMode"
              :hint="`${loginMode.code}, ${loginMode.name}`"
              :items="loginModeItems"
              item-text="name"
              item-value="code"
              return-object
              class="form-select"
              outlined
              dense
              solo
            ></v-select>
            <v-text-field
              ref="account"
              v-model="user.account"
              :label="$t('ID')"
              class="form-login"
              clearable

            />
            <v-text-field
              ref="password"
              v-model="user.password"
              @keyup.enter="onLogin"
              :label="$t('Password')"
              type="password"
              class="form-login"
              clearable
            />
            <v-text-field
              v-model="user.domain"
              label="Domain"
              v-show="domainInputShow"
              class="form-login"
              clearable
            />
            <!-- <v-checkbox
              v-model="staySignedIn"
              label="Stay Signed In"
              color="indigo"
              value="indigo"
              hide-details
            ></v-checkbox> -->
            <div class="d-flex justify-space-between align-center">
            <v-checkbox
                v-model="staySignedIn"
                :label="$t('Stay Signed In')"
                class="form-checkbox _login"
                hide-details
              ></v-checkbox>
              <v-dialog v-model="dialog" width="500">
                <template v-if="false" v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" text class="link">{{
                    $t('Forgot Password?')
                  }}</v-btn>
                </template>
                <v-card class="popup add_store_popup">
                  <h3 class="page-title-bar">
                    <i class="ico ico-overview"></i>{{ $t('Reset Password') }}
                  </h3>
                  <p class="guide_txt">
                    {{
                      $t(
                        'Answer the following questions to reset your password'
                      )
                    }}.
                  </p>
                  <v-row class="mt-5">
                    <v-col>
                      <p>{{ $t('Security Question 1') }} *</p>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        clearable
                        label="What was the name of your first pet?"
                        class="form-input"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p>{{ $t('Security Question 2') }} *</p>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        clearable
                        label="What is your father’s name?"
                        class="form-input"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p>{{ $t('Security Question 3') }} *</p>
                      <v-text-field
                        class="form-input"
                        label="What is your dream job?"
                        outlined
                        dense
                        hide-details
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions class="d-flex justify-center">
                    <v-btn @click="dialog = false" text icon class="btn">{{
                      $t('Submit')
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-form>
        </v-card-text>
        <p v-if="licenseExpired" class="txt-activation">
          <img src="@/assets/img/loginerror.png" alt="" />
          License has expired. Please activate license.
        </p>
        <v-btn
          v-if="licenseExpired"
          @click="showLoginLicenseActivation"
          class="btn-activation"
          text
          >License Activation
        </v-btn>
        <license-activation
          :license-expired="licenseExpired"
          @messageAlert="messageAlert"
          @hideActivateLicenseBtn="hideActivateLicenseBtn"
        />
        <p v-show="passwordExpired" class="txt-activation">
          <img src="@/assets/img/loginerror.png" alt="" />
          User's password has expired.
        </p>
        <v-btn
          v-if="passwordExpired"
          @click="showLoginPasswordChange"
          class="btn-activation"
          >{{ $t('Change Password') }}</v-btn
        >
        <password-change
          :account="passwordExpiredAccount"
          :passwordexpired="passwordExpired"
          @messageAlert="messageAlert"
          @hideChangePasswordBtn="hideChangePasswordBtn"
        />
        <v-btn @click="onLogin" v-show="!keycloakloginform" class="btn-login">{{ $t('Login') }}</v-btn>
      </v-card>
      <p class="copyright">
         <span v-if="loginLogoImage==='' || loginLogoImage===undefined  || loginLogoImage===null ">
        <img src="@/assets/img/logo-login.jpg" alt="solum" /><br />@2015-2022 SOLUM
        Proprietary and Confidential

        </span>
        <span v-else><img :src="loginLogoImage" alt="solum"  style="width:148px;height:26px"/><br />@2015-2022 SOLUM
        Proprietary and Confidential</span>
      </p>
    </div>
    <!--Message Box-->
    <div>
      <v-dialog v-model="messageDialog" width="300">
        <v-card class="popup add_store_popup" align="center" justify="center">
          <v-row align="center">
            <v-col>
              <span v-text="messageText"></span>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-center" v-if="!okBtn">
            <v-btn text icon @click="doForceLogin" class="btn" max-width="100"
              >Yes</v-btn
            >
            <v-btn text icon @click="messageDialog = false" class="btn" max-width="100"
              >Cancel</v-btn
            >
          </v-card-actions>
          <v-card-actions class="d-flex justify-center" v-if="okBtn">
            <v-btn text icon @click="messageDialog = false;keycloakRedirect()" class="btn"
              >Ok</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- Loading Box -->
    <loading-box :loadingBox="loadingBox" />
  </div>
</template>

<script>
// Utility
import User from '@/models/user'
import { signIn } from '@/adLogin/authPopup'
import EventBus from '@/plugins/eventBus'
import commons from '@/plugins/commons'
import configs from '@/plugins/configs'
// Components
import LicenseActivation from '@/views/LoginLicenseActivation'
import PasswordChange from '@/views/LoginPasswordChange'
// Mixins
import LoadingBoxParent from '@/mixins/LoadingBoxParent'

// keycloak
import Keycloak from 'keycloak-js'
import Vue from 'vue'
// import VueLogger from 'vuejs-logger'

const msgs = {
  passwordExpired: 'Your password was expired.'
}
const requests = {
  getCustomImageApi: {
    method: 'get',
    url: '/common/config/imageList'
  }

}

export default {
  name: 'Login',
  mixins: [LoadingBoxParent],
  components: {
    LicenseActivation,
    PasswordChange
  },
  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      dialog: false,
      messageDialog: false,
      messageText: '',
      loginModeItems: [
        { code: 'local', name: this.$t('Local Mode Login') },
        { code: 'domain', name: this.$t('Domain Mode Login') }
      ],
      loginMode: { code: 'local', name: 'Local Mode Login' },
      domainInputShow: false,
      user: new User('', ''),
      licenseExpired: false,
      passwordExpired: false,
      passwordExpiredAccount: '',
      staySignedIn: false,
      forceLogin: false,
      okBtn: false,
      loginLogoImage: {},
      loginMainImage: {},
      keycloakloginform: false,
      errorcode: ''
    }
  },
  methods: {
    messageAlert (text) {
      this.messageText = text
      this.messageDialog = true
    },
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    onLogin () {
      try {
        this.openLoadingBox('Loading')
        if (commons.isNull(this.user.account)) {
          this.$refs.account.$el.getElementsByTagName('input')[0].focus()
          return
        }
        if (commons.isNull(this.user.password)) {
          this.$refs.password.$el.getElementsByTagName('input')[0].focus()
          return
        }
        this.user.loginMode = this.loginMode.code
        this.user.force = this.forceLogin
        this.$store
          .dispatch('auth/login', this.user)
          .then(async res => {
            this.$store.dispatch(
              'dataStore/updateStaySignedIn',
              this.staySignedIn
            )
            this.$store.dispatch('dataStore/updateActivateFeatures', res.activateFeatures)
            this.$store.dispatch('dataStore/updatePermissionKey', res.permissionKey)
            this.$store.dispatch('dataStore/updatePermissionValue', res.permissionValue)
            this.$store.dispatch('dataStore/INIT_SELECTED_STORE', this.$store)
            this.$router.push('/').catch(() => {})
          })
          .catch(error => {
            this.loading = false
            this.messageText = error.responseMessage || 'Failed to login'
            this.messageDialog = true
            this.errorcode = error.responseCode
            switch (error.responseCode) {
              case '401':
                if (error.responseMessage === msgs.passwordExpired) {
                  this.passwordExpiredAccount = this.user.account
                  this.passwordExpired = true
                }
                this.okBtn = true
                break
              case '402':
                this.licenseExpired = true
                break
              case '444':
                this.okBtn = false
                break
              default:
                this.okBtn = true
                break
            }
          })
      } catch (error) {
        console.debug(`The login proccess has failed. error: ${error}`)
      } finally {
        this.closeLoadingBox()
      }
    },
    // Keycloak login page Redirection based on API Response
    keycloakRedirect () {
      if (configs.keycloakLogin === true && this.errorcode === '401') {
        const logoutUrl = configs.keycloakurl + '/realms/' + configs.keycloakrealm + '/protocol/openid-connect/logout?post_logout_redirect_uri=' + window.location.origin + process.env.BASE_URL + 'login'
        window.location.href = logoutUrl
      }
    },
    hideActivateLicenseBtn () {
      this.licenseExpired = false
    },
    hideChangePasswordBtn () {
      this.passwordExpired = false
    },
    showLoginLicenseActivation () {
      EventBus.$emit('showLoginLicenseActivation')
    },
    showLoginPasswordChange () {
      EventBus.$emit('showLoginPasswordChange')
    },
    doForceLogin () {
      this.forceLogin = true
      this.messageDialog = false
      this.onLogin()
    },
    // idleLogout for local server Keycloak
    idleLogout (idletime) {
      var idle
      window.onload = resetTimer
      window.onmousemove = resetTimer
      window.onmousedown = resetTimer // catches touchscreen presses as well
      window.ontouchstart = resetTimer // catches touchscreen swipes as well
      window.onclick = resetTimer // catches touchpad clicks as well
      window.onkeydown = resetTimer
      window.scroll = resetTimer
      window.addEventListener('scroll', resetTimer, true) // improved; see comments
      function yourFunction () {
        const logoutUrl = configs.keycloakurl + '/realms/' + configs.keycloakrealm + '/protocol/openid-connect/logout?post_logout_redirect_uri=' + window.location.origin + process.env.BASE_URL + 'login'
        window.location.href = logoutUrl
      }
      function resetTimer () {
        clearTimeout(idle)
        idle = setTimeout(yourFunction, idletime * 1000) // time is in MileSeconds
      }
    }
  },
  watch: {
    loginMode (val) {
      if (this.loginMode.code === 'domain') {
        this.domainInputShow = true
      } else {
        this.domainInputShow = false
      }
    }
  },
  created () {
    commons.clearVuex()
  },
  mounted () {
    if (this.productionType === 'cloud') {
      signIn(this.user).then(async account => {
        this.user.account = account
        await this.onLogin()
      })
    }
    // KeyCloak Based Login
    if (configs.keycloakLogin === true) {
      this.keycloakloginform = true
      // keycloak integrations
      const initOptions = {
        url: configs.keycloakurl,
        realm: configs.keycloakrealm,
        clientId: configs.keycloakclientId,
        onLoad: configs.keycloakonLoad,
        'ssl-required': 'none'
      }
      const keycloak = Keycloak(initOptions)
      keycloak
        .init({ onLoad: initOptions.onLoad, checkLoginIframe: false })
        .then(async (auth) => {
          if (!auth) {
            window.location.reload()
          } else {
            this.tokenexpiry = keycloak.idTokenParsed.exp - keycloak.idTokenParsed.iat
            this.idletime = keycloak.refreshTokenParsed.exp - keycloak.refreshTokenParsed.iat
            console.log(this.idletime)
            console.log(this.tokenexpiry)
            this.idleLogout(this.idletime)
            this.$store.commit('auth/UPDATE_TOKEN', keycloak.token)
            await this.onLogin()
          }
          // Token Refresh
          setInterval(() => {
            keycloak.updateToken(this.idletime * 1000)
              .then((refreshed) => {
                if (refreshed) {
                  this.$store.commit('auth/UPDATE_TOKEN', keycloak.token)
                }
              })
              .catch(() => {
                Vue.$log.error('Failed to refresh token')
              })
          }, this.tokenexpiry * 1000)
        })
        .catch(() => {
          //
        })
    }
    /// end keycloak
    this.clearTabindex()
    if (configs.ApiUrl === undefined || configs.ApiUrl === 'undefined' || configs.ApiUrl === '' || configs.ApiUrl === null) {
      this.$store.dispatch('dataStore/updateMenuLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginMainImage', '')
    }
    const url = configs.ApiUrl + requests.getCustomImageApi.url
    this.$utils.callAxios(requests.getCustomImageApi.method, url).then(async (res) => {
      this.$store.dispatch('dataStore/updateMenuLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginMainImage', '')
      if (res.status === 200) {
        var getImageList = res.data.imageList
        for (var i = 0; i < getImageList.length; i++) {
          if (getImageList[i].location === 'LoginMainImage') {
            this.$store.dispatch('dataStore/updateLoginMainImage', getImageList[i].fileData)
          } if (getImageList[i].location === 'LoginLogoImage') {
            this.$store.dispatch('dataStore/updateLoginLogoImage', getImageList[i].fileData)
          } if (getImageList[i].location === 'MenuLogoImage') {
            this.$store.dispatch('dataStore/updateMenuLogoImage', getImageList[i].fileData)
          }
        }
      } else {
        this.$store.dispatch('dataStore/updateMenuLogoImage', '')
        this.$store.dispatch('dataStore/updateLoginLogoImage', '')
        this.$store.dispatch('dataStore/updateLoginMainImage', '')
      }
    }).catch(error => {
      console.debug(error)
      this.$store.dispatch('dataStore/updateMenuLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginLogoImage', '')
      this.$store.dispatch('dataStore/updateLoginMainImage', '')
    })
    this.loginLogoImage = this.$store.state.dataStore.LoginLogoImage
    this.loginMainImage = this.$store.state.dataStore.LoginMainImage
  }
}
</script>

<style scoped>
.login {
  height: 100%;
}
.login .bg {
  width: 50%;
  background: url(../assets/img/bg-login.jpg) no-repeat center center / cover;
}
.login .bg1 {
  width: 50% !important;
  /* background-size: 750px 750px !important */
}
.login .loginBox {
  position: relative;
  width: 50%;
}
.login .loginBox .loginForm {
  width: auto;
}
.login .loginBox .loginForm .login-tit {
  font-size: var(--font40);
  font-weight: 700;
  color: #001e38;
  letter-spacing: 0.18em;
}
.login .loginBox .loginForm .login-txt {
  font-size: var(--font20);
  color: #4d4f5c;
}
.v-btn.link {
  padding: 0;
  font-size: var(--font18);
  color: #43425d;
  text-transform: none;
  letter-spacing: 0;
}
.form-login {
  font-size: var(--font20);
}
.form-login .v-label {
  font-size: var(--font20) !important;
}
.btn-login {
  display: block;
  width: 150px;
  height: 40px !important;
  margin: 8px auto 0;
  background: #001e38 !important;
  color: #fff;
  border-radius: 5px;
  font-size: var(--font16);
}
.btn-activation {
  display: block;
  width: 150px;
  height: 40px !important;
  margin: 8px auto 0;
  background: #e27070 !important;
  color: #fff;
  border-radius: 5px;
  font-size: var(--font16);
}
.txt-activation {
  margin: 10px 0 20px;
  color: #e27070;
  font-size: var(--font18);
  text-align: center;
}
.copyright {
  position: absolute;
  bottom: 5vh;
  left: 0;
  width: 100%;
  margin-bottom: 0;
  text-align: center;
  font-size: var(--font11);
  color: #43425d;
}
.copyright img {
  margin-bottom: 5px;
}
.guide_txt {
  font-size: var(--font22);
  font-weight: 700;
}
</style>
